import React, { useEffect, useRef, useState } from 'react';

import { ENV } from '../../env';
import { zeosDialog } from '../Shared/confirm-dialog/ConfirmDialog';
import { ZeosButton } from '../Shared/ZeosButton';

interface IProps {
  bin: string | undefined;
  onCloseSelector: () => void;
  propertyId: number | undefined;
  zeosUserId: number | undefined;
}

export const CarbonClearEmbed = (props: IProps) => {
  const [ccOpen, setCcOpen] = useState<boolean>(false);
  const ccWindowRef = useRef<Window | null>(null);

  const windowFeatures = "left=100,top=100,width=1000,height=1000";

  const openCarbonClear = (target: "register" | "connectToRewire") => {
    const path = target === "register" ? "register" : "connectToRewire";
    const url = `${ENV.CARBON_CLEAR_BASE_URL}/${path}?BIN=${props.bin}&rewireId=${props.propertyId}`;
    const ccWindow = window.open(url, "carbonClearWindow", windowFeatures);
    if (!ccWindow) {
      zeosDialog("Error");
      return;
    }
    ccWindowRef.current = ccWindow;
    setCcOpen(true);
  };

  useEffect(() => {
    if (!ccOpen || !ccWindowRef.current) return;

    const id = setInterval(() => {
      if (ccWindowRef.current?.closed) {
        clearInterval(id);
        ccWindowRef.current = null;
        setCcOpen(false);
        props.onCloseSelector();
      }
    }, 200);

    return () => clearInterval(id);
  }, [ccOpen, props]);

  return (
    <div className=" flex flex-col items-center justify-center  text-center">
      <p>
        We are securely redirecting you Carbon Clear, our partner in managing
        LL97 compliance.
      </p>
      <p>
        When done, please close the window. We will notify you when the
        registration process is complete.
      </p>
      <div className="w-50 text-center mt-3 mb-3">
        <ZeosButton
          label={"Create a New Carbon Clear Account"}
          onPress={() => openCarbonClear("register")}
          type={"button"}
          mode={"action"}
          hackWidth
        />
      </div>
      <div className="w-50 text-center ">
        <ZeosButton
          label={"Link to your Existing Carbon Clear Account"}
          onPress={() => openCarbonClear("connectToRewire")}
          type={"button"}
          mode={"action"}
          hackWidth
        />
      </div>
    </div>
  );
};
